export { default } from 'src/modules/SignUp/SignUpPage';
